import React from 'react';
import { Link } from 'react-router-dom';
import { StaticPageLayout } from './StaticPageLayout';
import { VideoGuidesSection } from './VideoGuidesSection';

export const SupportPage: React.FC = () => (
  <StaticPageLayout
    kicker="Мы на связи"
    title="Поддержка QPrice"
    documentTitle="QPrice — Поддержка"
  >
    <div className="qp-contact-grid">
      <a href="tel:+77772468483" className="qp-contact-card">
        <span className="qp-contact-card-label">Телефон</span>
        <span className="qp-contact-card-value">+7 777 246 84 83</span>
        <span className="qp-contact-card-note">Звонок по Казахстану</span>
      </a>
      <a
        href="https://wa.me/77772468483"
        target="_blank"
        rel="noopener noreferrer"
        className="qp-contact-card"
      >
        <span className="qp-contact-card-label">WhatsApp</span>
        <span className="qp-contact-card-value">Написать в чат</span>
        <span className="qp-contact-card-note">Самый быстрый способ связи</span>
      </a>
      <a href="mailto:partner@qprice.kz" className="qp-contact-card">
        <span className="qp-contact-card-label">Почта</span>
        <span className="qp-contact-card-value">partner@qprice.kz</span>
        <span className="qp-contact-card-note">Отвечаем в течение рабочего дня</span>
      </a>
    </div>

    <VideoGuidesSection />

    <div className="qp-support-section">
      <h2>Клиентам приложения</h2>
      <p>
        Не работает регистрация, не приходит код, не отображаются скидки или возникли вопросы
        по предложению партнёра — напишите нам в WhatsApp или на почту, разберёмся.
      </p>
      <p>
        <strong style={{ color: 'var(--qp-ink)' }}>Удалить аккаунт</strong> можно прямо в
        приложении: «Меню» → «Профиль» → «Удалить аккаунт». Данные удаляются сразу, без
        отложенного срока. Если войти не получается — отправьте запрос с номера телефона,
        на который зарегистрирован аккаунт, удалим и подтвердим. Что именно удаляется — в{' '}
        <Link to="/privacy">политике конфиденциальности</Link>.
      </p>
    </div>

    <div className="qp-support-section">
      <h2>Жалобы</h2>
      <p>
        Оскорбления, спам или ложная информация в отзыве — пожалуйтесь прямо из приложения:
        меню «⋯» на карточке отзыва → «Пожаловаться». Там же можно заблокировать автора.
        <strong style={{ color: 'var(--qp-ink)' }}> Каждую жалобу разбираем в течение 24 часов</strong>{' '}
        и снимаем отзыв, если он нарушает <Link to="/ugc-rules">правила публикации</Link>.
      </p>
      <p>
        Заведения могут написать нам напрямую — разберём отзыв и ответим о решении.
      </p>
      <p>
        <strong style={{ color: 'var(--qp-ink)' }}>Жалоба на заведение</strong> — не дали скидку,
        закрыто, неверные данные: «⋯» на странице заведения → «Пожаловаться на заведение».
        Разбираем так же, в течение 24 часов.
      </p>
    </div>

    <div className="qp-support-section">
      <h2>Партнёрам</h2>
      <p>
        Поможем с регистрацией заведения, настройкой каталога и скидок, вопросами по подписке
        и оплате. Позвоните или напишите в WhatsApp — проведём по шагам.
      </p>
    </div>

    <div className="qp-support-section">
      <h2>Документы</h2>
      <p>
        <Link to="/terms/clients">Пользовательское соглашение для клиентов</Link>
        <br />
        <Link to="/terms/partners">Публичная оферта для партнёров</Link>
        <br />
        <Link to="/ugc-rules">Правила публикации отзывов и фотографий</Link>
        <br />
        <Link to="/privacy">Политика конфиденциальности</Link>
      </p>
    </div>
  </StaticPageLayout>
);
